package fr.frux.core.common.auth

import fr.frux.core.common.storage.KeyValueStore
import fr.frux.core.common.storage.browserStorage

/**
 * Web implementation backed by the browser's localStorage.
 * Not encrypted — readable by XSS. Acceptation actée par l'ADR 0022 (adossée à la rotation avec
 * détection de rejeu de l'ADR 0019 et à la CSP sans script inline) ; les déclencheurs qui
 * rouvrent la décision cookie HttpOnly y sont listés.
 *
 * Stockage bloqué par le navigateur (#610) : la session tient en mémoire jusqu'au rechargement.
 */
internal class WebTokenStorage(
    private val store: KeyValueStore = browserStorage.store,
) : TokenStorage {
    private val key = "frux_tokens"
    private val legacyKey = "frux_token"

    override suspend fun save(tokens: Tokens) {
        store.setItem(key, tokens.encode())
    }

    override suspend fun load(): Tokens? {
        val decoded = decodeTokens(store.getItem(key))
        // Format pre-#26 (JWT seul) : plus rejouable sans refresh token, purger.
        if (decoded == null && store.getItem(legacyKey) != null) {
            store.removeItem(legacyKey)
        }
        return decoded
    }

    override suspend fun clear() {
        store.removeItem(key)
        store.removeItem(legacyKey)
    }
}

actual fun createTokenStorage(): TokenStorage = WebTokenStorage()
